import http from './axios';

const baseURL = ''

const upload = params => {
  // 上传接口调整timeout时间为30s，防止没上传完就超时导致上传失败  增加t参数进行加签操作
  return http.post(`${baseURL}/gift/upload?t=${Math.random()}`, params, { headers: { 'content-type': 'text/plain;charset=UTF-8' }, timeout: 30*1000 })
}

const getUserInfo = () => {
  return http.post('/userservice/getUserInfo')
}

const createWorksheet = params => {
  return http.post('/webapp/v1/worksheet/create', params);
}

export default {
  upload,
  getUserInfo,
  createWorksheet
}